<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
              :showBtn="false"
              :showAddNew="false"
              title="Attendance Import List"
            >
            <template #extra-btn>
              <a
                  download
                  href="/file/import-attendance-file.xlsx"
                  class="btn btn-outline-secondary waves-effect waves-float waves-light"
              >Download Sample
              </a>
            </template>
          </TitleButton>
            <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
        </div>

        <div class="row p-2">

            <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
                <button @click="uploadCsv" class="btn btn-primary waves-effect waves-float waves-light">
                    Browse
                </button>
            </div>
        </div>

        <div class="p-2">
            <div v-for="(item, index) in csvRow" :key="index">
                <div class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center">
                       <span v-if="['pending', 'processing'].includes(item.status)" class="cursor-pointer px-1" @click="gotoUpload(item.id)">
                           id: {{ item.id }} Dataset: {{ item.batch }}
                        </span>
                       <span v-else class="px-1">
                        id: {{ item.id }} Dataset: {{ item.batch }}
                       </span>
                    <button class="btn btn-danger text-capitalize btn-sm" @click=deleteBulkLog(item.id)><i class="fa fa-trash"></i> {{ item.status }}</button>
                </div>
              <div>
              </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import { inject, onMounted, ref } from "vue";
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll.js'
import { useRoute, useRouter } from 'vue-router';
import handleInventory from "@/services/modules/inventory";

const { uploadAttendance, deleteBulkUploadLog } = handleHrPayroll();
const { fetchCsvRow } = handleInventory();
const uploader = ref(null);
const csvRow = ref([]);

const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');

const gotoUpload = (id) => {
    const query = Object.assign({}, route.query);
    query.rowId = id;

    router.push({name: 'upload-attendance', params: route.params, query: query});
}

const getCsvRow = async () => {
    let query = `?company_id=${route.params.companyId}&type=attendance&is_all=1`;
    csvRow.value = []
    await fetchCsvRow(query).then((res) => {
        if(!res.status) {
            return
        }
        csvRow.value = res.data
    }).catch((e) => {
        console.log(e)
    });
}

const uploadCsv = () => {
    uploader.value.click();
}

const deleteBulkLog = async (id) => {
  if(! confirm('Are you sure to remove this log?')) return;
  const query = `?company_id=${route.params.companyId}`;

  await deleteBulkUploadLog(query, id).then((res) => {
    if (!res.status) return showError(res.message);
    getCsvRow()
    showSuccess(res.message);
  }).catch(err => {
    console.log(err)
  }).finally(() => {

  })
}

const handleFileUpload = async (event) => {

    const selectedFile = event.target.files[0];

    let fd = new FormData();
    fd.append('company_id', route.params.companyId)
    fd.append('sheet', selectedFile)
    fd.append('type', 'attendance')
    
    await uploadAttendance(fd).then((res) => {
        if(!res.status) {
            showError(res.message)
            return
        }
        
        showSuccess(res.message)
        getCsvRow();
    })
    .catch((e) => {
        showError('Something went wrong')
    });
}

onMounted(() => {
    getCsvRow();
})

</script>